require('./bootstrap');
window.finished = true;
window.onbeforeunload = function(e){
    if(!window.finished) {
        e.returnValue = 'Are you sure you want to leave?';
    }
};
axios.get('/trans').then(function (response) {
    window.trans = response.data;
    require('./vues');
})
